<template>



    <v-container style="padding-top: 80px !important">

        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>

        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showForm">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-account-search</v-icon>
                <p style="color: white;">Buscar</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="8">

                            <div class="mt-2">
                                <span style="font-weight: bold;">Nombre o Razon Social:</span>

                            </div>
                            <div class="button-container ">

                                <v-text-field class="align-left-button" v-model="datos.nombre"
                                    v-on:blur="datos.nombre = datos.nombre != null ? datos.nombre.trim() : null"
                                    outlined :rules="rulestext" maxlength="30" @keydown.enter.prevent="buscarEnter()"
                                    dense>
                                </v-text-field>
                                <v-btn class="align-right-button" color="primary" max @click="buscar()">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>



                            </div>





                        </v-col>

                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-account</v-icon>
                <p style="color: white;">Proveedores</p>

            </v-card-title>
            <v-form>
                <div>

                    <v-card-text v-if="noResults">

                        <div class="mx-auto text-center" style="margin-top: 15px; margin-bottom: 15px">

                            <v-card-text class="font-weight-bold"> Sin Resultados</v-card-text>

                        </div>



                    </v-card-text>
                    <v-card-text>


                        <v-row v-if="showBusqueda">
                            <v-col v-for="(item, index) in busquedaResult" :key="index" cols="12" sm="6" md="4" lg="3">

                                <v-card class="AboCard">


                                    <v-card-title v-if="item.prestatus == 'A'" class="pa-5 pb-3 cardTittle">

                                        <p style="color: white; font-size:15px"> <span
                                                style="color: white; font-size:15px" class="font-weight-bold"> Clave:
                                            </span>{{ item.prclave }}</p>

                                    </v-card-title>

                                    <v-card-title v-if="item.prestatus != 'A'" class="pa-5 pb-3 cardTittleDis">

                                        <p style="color: white; font-size:15px"> <span
                                                style="color: white; font-size:15px" class="font-weight-bold"> Clave:
                                            </span>{{ item.prclave }}</p>

                                    </v-card-title>

                                    <div class="mx-auto text-center" style="margin-top: 15px; margin-bottom: 15px">



                                        <v-badge v-if="item.prestatus == 'A'" class="badgeClass" offset-y="15"
                                            offset-x="18" overlap bottom color="green" icon="mdi-check">
                                            <v-avatar size="61">
                                                <v-img src="https://ausa.com.mx/img/Images/perfil.png"
                                                    alt="Avatar"></v-img>
                                            </v-avatar>
                                        </v-badge>

                                        <v-badge v-if="item.prestatus != 'A'" class="badgeClass" offset-y="15"
                                            offset-x="18" overlap bottom color="blue-grey" icon="mdi-minus">
                                            <v-avatar size="61">
                                                <v-img src="https://ausa.com.mx/img/Images/perfil.png"
                                                    alt="Avatar"></v-img>
                                            </v-avatar>
                                        </v-badge>

                                    </div>



                                    <div class="datosDiv">

                                        <v-card-text><span class="font-weight-bold">Nombre o Razón social:</span>
                                            {{ item.prnombre }}</v-card-text>

                                        <v-card-text><span class="font-weight-bold">Nombre comercial:</span>
                                            {{ item.prnomcom }}</v-card-text>
                                        <v-card-text><span class="font-weight-bold">Localidad:</span>
                                            {{ item.lonombre }}</v-card-text>

                                    </div>



                                    <v-spacer></v-spacer>

                                    <div class="mx-auto text-center buttonCard">

                                        <v-btn outlined @click="DetalleAbo(item.prclave)" style="align-self:center"
                                            class="text-center" color="primary">
                                            Mas Información
                                        </v-btn>

                                    </div>

                                </v-card>

                            </v-col>
                        </v-row>

                        <v-row>
                            <div class="mx-auto text-center" style="margin-top: 15px; margin-bottom: 15px">



                                <v-progress-circular v-if="loading && endPage == false" color="primary"
                                    indeterminate></v-progress-circular>

                            </div>
                        </v-row>



                    </v-card-text>

                </div>

            </v-form>
        </v-card>
    </v-container>
</template>




<script>
import reporteGeneral from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import Proveedor from '@/services/Proveedor/Proveedor.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            endPage: false,
            loading: false,
            noResults: false,
            pagina: 1,
            busquedaResult: [],
            datosRep: [],
            showForm: true,
            showBusqueda: false,
            validForm: true,
            prnombre: '',
            datos: {
                nombre: null,
                prclave: '',
            },
            datosBusqueda: {
                nombre: null,
                prclave: '',
            },
            rulestext: [
                v => {
                    if (v == null || v == '') {
                        return 'Ingrese el nombre del proveedor'
                    }
                    else {
                        if (v.length < 3) {
                            return 'Mínimo 3 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],


        }
    },
    watch: {

    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {

        async DetalleAbo(prclaveP) {


            let reporte = {
                nrreporte: null,
                svindice: null,
                aiclave: null,
                svfhconclusion: null,
                prclave: String(prclaveP)

            };


            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);;
        },
        limpiar() {
            this.datos.nombre = null;

            this.datosBusqueda.nombre = null;

            this.showBusqueda = false;
            this.$refs.form.resetValidation();

        },
        async buscar() {


            this.$refs.form.validate();
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.showBusqueda = true;
                this.pagina = 1;
                this.busquedaResult = [];
                const nombre = this.datos.nombre.trim();

                this.datosBusqueda.nombre = nombre;

                await Proveedor.Proveedores_Busqueda(this, nombre, this.pagina).then(response => {

                    if (response.length > 0) {
                        this.noResults = false;
                        this.busquedaResult = response;
                        this.endPage = false;
                    } else {
                        this.noResults = true;
                        this.endPage = true;
                    }


                    this.loading = false;

                });

            }



        },
        async buscarEnter() {



            if (this.datos.nombre != null) {

                this.datos.nombre = this.datos.nombre.trim();

                if (this.datos.nombre.length >= 3) {

                    this.datos.nombre = this.datos.nombre.trim();

                    this.buscar();
                }


            }
            else {
                this.$refs.form.validate();
            }


        },
        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },
        async buscarPush() {



            if (this.datosBusqueda.nombre != null && this.datosBusqueda.nombre != "") {


                if (this.endPage == false) {
                    this.loading = true;

                    this.showBusqueda = true;

                    this.pagina += 1;

                    const nombre = this.datos.nombre.trim();

                    this.datosBusqueda.nombre = nombre;



                    await Proveedor.Proveedores_Busqueda(this, nombre, this.pagina).then(response => {

                        this.loading = false;

                        if (response.length > 0) {
                            for (var i = 0; response.length > i; i++) {

                                this.busquedaResult.push(response[i]);
                            }
                        } else {
                            this.endPage = true;
                        }






                    });
                }

            }



        },
        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },
    },
    async mounted() {
        window.addEventListener('scroll', () => {
            this.bottom = this.bottomVisible()


            if (this.bottom == true) {

                this.buscarPush();


            }
        })

    },
    watch: {

    },
    created() {


    }
}
</script>

<style scoped>
.cardTittle {
    background-color: #43a047;
}

.cardTittleDis {
    background-color: #808080;
}

.AboCard {
    min-height: 540px;
    max-height: 540px;
    height: auto;
}

.datosDiv {
    height: 350px;
    overflow-y: scroll;
}

.buttonCard {
    position: absolute;
    right: 0;
    bottom: 0;
    margin-bottom: 20px;
    left: 0;
}


.button-container {
    display: flex;
}

.align-left-button {
    float: left;
    width: auto;
}

.align-right-button {
    float: left;
    width: 20px !important;
    height: 40px !important;
}
</style>
